import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { Capacitor } from "@capacitor/core";

export const useCamera = () => {
  const takePhoto = async () => {
    const options = {
      resultType: CameraResultType.Base64,
      source: CameraSource.Camera,
      quality: 100,
    };
    const cameraPhoto = await Camera.getPhoto(options);
    return "data:image/png;base64," + cameraPhoto.base64String;
    // return Capacitor.convertFileSrc(cameraPhoto.webPath);
  };

  return {
    takePhoto,
  };
};

